import { SagaIterator } from "@redux-saga/core";
import { call, put, takeLatest } from "redux-saga/effects";
import { PageAlert } from "capitalrx-components";

import apiService from "@/App/service";
import { ActionTypes } from "@/App/constants/actionTypes";
import { getBatchTestClaimActions } from "@/App/actions";

function* getBatchTestClaim(payload: string): Generator {
  return yield apiService({
    url: "/transmission/batch_test/get",
    method: "POST",
    data: {
      id: payload,
    },
  });
}

export function* getBatchTestClaimWorker(action: ReturnType<typeof getBatchTestClaimActions.getTestClaim>): SagaIterator {
  const { payload } = action;
  const { getTestClaimResults } = getBatchTestClaimActions;
  const { showPageAlert } = PageAlert;

  try {
    const batchTestClaim = yield call(getBatchTestClaim, payload);
    yield put(getTestClaimResults(batchTestClaim));
  } catch (error) {
    const { data: { message = "" } = {} } = error;
    yield put(showPageAlert({ show: true, type: "error", message: message }));
  }
}

export default function* getBatchTestClaimWatcher(): SagaIterator {
  yield takeLatest(ActionTypes.GET_BATCH_TRANSMISSION_TEST_CLAIM, getBatchTestClaimWorker);
}
